import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {getDirectOffersByAccommodation} from "../../shared/queries";
import {useHistory} from "react-router-dom";
import {Button} from "@heroui/button";
import {Card, CardBody, CardHeader} from "@heroui/card";
import {Image} from "@heroui/image";
import {useAppDispatch} from "../../hooks/redux";
import {setCurrentOffer} from "../../store/slices/beDirectSlice";

export default function Offers () {

    const history = useHistory()
    const dispatch = useAppDispatch()

    const {
        currentHotel,
        currentHotelObject
    } = useSelector((state: RootState) => state.hotels)

    const {
        data
    } = useQuery(['offers', currentHotel], () => getDirectOffersByAccommodation(currentHotel), {
        enabled: (currentHotel !== null && currentHotel !== undefined)
    })

    return (
        <div>
            <div className={'border rounded-md mt-6 overflow-hidden'}>
                <div className="p-6">
                    <div className="text-3xl font-bold text-slate-700">
                        Messaggi personalizzati e intelligenti con test A/B
                    </div>
                    <div className="text-slate-600 text-lg mt-4">
                        crea messaggi personalizzati e dinamici in base alla provenienza dell'ospite, la stagionalità e altri parametri rilevati dal nostro script.
                        Sfrutta questo strumento per aumentare la visualizzazione delle tue tariffe e la conversione in fase d'acquisto.
                    </div>
                </div>

                {
                    (!data || data.length === 0)
                        ? <img src="/offerintro.png" alt=""/>
                        : <div className="p-8 grid grid-cols-3">
                            {
                                data.map(offer => (
                                    <Card isPressable onPress={() => {
                                        dispatch(setCurrentOffer(offer))
                                        history.push(`/app/bedirect/offer/${offer.idBeDirectOffer}`)
                                    }} className="py-4">
                                        <CardHeader className="pb-0 pt-2 px-4 flex-col items-start">
                                            <small className="text-default-500">{offer.published ? 'Pubblicata' : 'Bozza'}</small>
                                            <p className="text-tiny">dal {offer.startDate} al {offer.endDate}</p>
                                            <h4 className="mt-2 font-bold text-large">{offer.title}</h4>
                                        </CardHeader>
                                        <CardBody className="overflow-visible py-2">
                                            <Image
                                                alt="Card background"
                                                className="object-cover rounded-xl"
                                                src={offer.variants[0].coverUrl}
                                                width={270}
                                            />
                                        </CardBody>
                                    </Card>
                                ))
                            }
                        </div>
                }
            </div>


            <div className="mt-6">
                <Button color="primary" onClick={() => history.push('/app/bedirect/offer/create')}>Crea la tua campagna</Button>
            </div>
        </div>
    )

}
